
import update from 'immutability-helper'
import { useCallback, useEffect, useState } from "react";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import axios from 'axios';

import Painel from "../../components/dragDrop/Painel";
import { useLocation } from 'react-router';
import global from '../../utils/global';
import { ModalErro, ModalLoad, ModalSucesso } from '../../components/models/models';
import { tratamentoErro, cmToPx, getToken } from "../../utils/utils";
import Barcode from 'react-barcode';
import { wrapTextAsComponent } from '../../components/dragDrop/wrapTextAsComponent';
import ContainerPreview from '../../components/dragDrop/ContainerPreview';
import { 
    Grid,
    Box,
    Button,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    Typography,
    FormControl,
    FormControlLabel,
    Switch,
    Divider,
    Stack,
    Slider,
} from '@mui/material';

export default function CadEdicaoMoldes({user}) {

    const location = useLocation();
  
    // Pegando o valor de id da query string
    const queryParams = new URLSearchParams(location.search);
    const id_molde = queryParams.get('id');

    const fontFamilies = [
        'Arial', 'Verdana', 'Georgia', 'Times New Roman', 'Courier New', 'Trebuchet MS',
        'Impact', 'Comic Sans MS', 'Lucida Console', 'Tahoma', 'Helvetica', 'Courier',
        'Palatino', 'Garamond', 'Arial Black', 'sans-serif', 'serif', 'monospace'
    ];
    const fontWeights = ['normal', 'bold', '100', '200', '300', '400', '500', '600', '700', '800', '900'];

    //controles
    const [nomeMolde, setNomeMolde] = useState('');
    const [largura, setLargura] = useState(10);
    const [altura, setAltura] = useState(5);
    const [numeroColunas, setNumeroColunas] = useState(1);
    const [espacamento, setEspacamento] = useState(5);
    const [fontSizeNomeProduto, setFontSizeNomeProduto] = useState(15);
    const [fontSizePreco, setFontSizePreco] = useState(15);
    const [fontSizeDataValidade, setFontSizeDataValidade] = useState(15);
    const [fontWeithtNomeProduto, setFontWeigthNomeProduto] = useState('normal');
    const [fontWeithtPreco, setFontWeigthPreco] = useState('normal');
    const [fontWeithtDataValidade, setFontWeigthDataValidade] = useState('normal');
    const [fontFamilyNomeProduto, setFontFamilyNomeProduto] = useState('Arial');
    const [fontFamilyPreco, setFontFamilyPreco] = useState('Arial');
    const [fontFamilyDataValidade, setFontFamilyDataValidade] = useState('Arial');
    const [textTesteNomeProduto, setTextTesteNomeProduto] = useState('Nome do produto');
    const [textTestePreco, setTextTestePreco] = useState('Preço');
    const [textTesteDataValidade, setTextTesteDataValidade] = useState('Data de validade');
    const [textPreNomeProduto, setTextPreNomeProduto] = useState('');
    const [textPrePreco, setTextPrePreco] = useState('R$ ');
    const [textPreDataValidade, setTextPreDataValidade] = useState('Validade: ');
    const [codEanTeste] = useState('7894878067172');
    const [larguraCodBarras, setLarguraCodBarras] = useState(3);
    const [alturaCodBarras, setAlturaCodBarras] = useState(1);
    const [habilitaCodBarras, setHabilitaCodBarras] = useState(true);
    const [habilitaPreco, setHabilitaPreco] = useState(true);
    const [habilitaDataValidade, setHabilitaDataValidade] = useState(true);
    const [exibirCodEanNumerico, setExibirCodEanNumerico] = useState(false);
    const [fontSizeCodBarras, setFontSizeCodBarras] = useState(15);
    const [formatoCodBarras, setFormatoCodBarras] = useState('CODE128');
    const [limiteCharsPorLinha, setLimiteCharsPorLinha] = useState(20);
    const [limiteCharsTotal, setLimiteCharsTotal] = useState(50);

    const [larguraLinhaPreview, setLarguraLinhaPreview] = useState(15);
    const [showMoreConfigm , setShowMoreConfigm] = useState(false);

    //modal load
    const [showModalLoad, setShowModalLoad] = useState(false);

    //modal erro
    const [showModalErro, setShowModalErro] = useState(false);
    const [msgModalErro, setMsgModalErro] = useState('');
    const [funcPosModalErro, setFuncPosModalErro] = useState(() => () => {});

    //modal sucesso
    const [showModalSucesso, setShowModalSucesso] = useState(false);
    const [msgModalSucesso, setMsgModalSucesso] = useState('');
    const [funcPosModalSucesso, setFuncPosModalSucesso] = useState(() => () => {});

    //componentes do drap and drop
    const [boxes, setBoxes] = useState({
        a: { top: 20, left: 100, text: wrapTextAsComponent((textPreNomeProduto + textTesteNomeProduto).slice(0, limiteCharsTotal), parseInt(limiteCharsPorLinha)), fontSize: fontSizeNomeProduto, fontWeight: fontWeithtNomeProduto, fontFamily: fontFamilyNomeProduto },//nome do produto
        b: { top: 20, left: 250, text: habilitaPreco ? (textPrePreco + textTestePreco) : "", fontSize: fontSizePreco, fontWeight: fontWeithtPreco, fontFamily: fontFamilyPreco },//Preço
        c: { top: 100, left: 100, text: habilitaDataValidade ? (textPreDataValidade + textTesteDataValidade) : "", fontSize: fontSizeDataValidade, fontWeight: fontWeithtDataValidade, fontFamily: fontFamilyDataValidade },//data de validade
        d: { top: 50, left: 100, 
            text: habilitaCodBarras ? (
                codEanTeste != null && codEanTeste != '' && 
                <Barcode
                    value={codEanTeste}
                    width={cmToPx(larguraCodBarras) / 100}
                    height={cmToPx(alturaCodBarras)}
                    margin={5}
                    displayValue={exibirCodEanNumerico}
                    format={formatoCodBarras}
                    fontSize={fontSizeCodBarras}
                />)
                : null
        }//Cod ean do produto
    });

    //console.log(boxes);

    useEffect(() => {
        setBoxes(
            update(boxes, {
                a: {
                    $merge: { 
                        text: wrapTextAsComponent((textPreNomeProduto + textTesteNomeProduto).slice(0, limiteCharsTotal), parseInt(limiteCharsPorLinha)), 
                        fontSize: fontSizeNomeProduto, 
                        fontWeight: fontWeithtNomeProduto,
                        fontFamily: fontFamilyNomeProduto
                    }, // alterando texto, fontSize e fontWeight de 'a'
                },
                b: {
                    $merge: { 
                        text: habilitaPreco ? (textPrePreco + textTestePreco) : "", 
                        fontSize: fontSizePreco, 
                        fontWeight: fontWeithtPreco,
                        fontFamily: fontFamilyPreco
                    }, // alterando texto, fontSize e fontWeight de 'b'
                },
                c: {
                    $merge: { 
                        text: habilitaDataValidade ? (textPreDataValidade + textTesteDataValidade) : "", 
                        fontSize: fontSizeDataValidade, 
                        fontWeight: fontWeithtDataValidade,
                        fontFamily: fontFamilyDataValidade
                    }, // alterando texto, fontSize e fontWeight de 'c'
                },
                d: {
                    $merge: {
                        text: habilitaCodBarras ? <Barcode
                            value={codEanTeste}
                            width={cmToPx(larguraCodBarras) / 100}
                            height={cmToPx(alturaCodBarras)}
                            margin={5}
                            displayValue={exibirCodEanNumerico}
                            format={formatoCodBarras}
                            fontSize={fontSizeCodBarras}
                        />
                        : null
                    }
                }
            })
        );
    }, [textTesteNomeProduto, fontSizeNomeProduto, fontWeithtNomeProduto, textTestePreco, fontSizePreco, fontWeithtPreco, textTesteDataValidade, fontSizeDataValidade, fontWeithtDataValidade, fontFamilyNomeProduto, fontFamilyPreco, fontFamilyDataValidade, habilitaCodBarras, codEanTeste, larguraCodBarras, alturaCodBarras, exibirCodEanNumerico, fontSizeCodBarras, formatoCodBarras, textPreNomeProduto, textPrePreco, textPreDataValidade, habilitaPreco, habilitaDataValidade, limiteCharsPorLinha, limiteCharsTotal]); // Dependências para atualizar o estado quando qualquer um dos valores mudar

    useEffect(() => {

        const funcBuscarUnicoMolde = async () => {
            if(id_molde != null){
                //buscar molde pelo id
                //console.log("uuid: ", id_molde);
                
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: global.baseUrl + '/AppEtiqueta/BuscarUnicoMolde?uuid=' + id_molde,
                    headers: { 
                        'Authorization': await getToken(user.clientKey),
                        'Content-Type': 'application/json'
                    }
                };

                axios.request(config)
                .then((response) => {
                    //console.log(response);
                    if(response.data.code == 0){
                        
                        let dados = response.data.content;
                        console.log(dados);
                        setNomeMolde(dados.nomeMolde);
                        setAltura(dados.altura);
                        setLargura(dados.largura);
                        setEspacamento(dados.espacamento);
                        setNumeroColunas(dados.numColunas);
                        setLarguraCodBarras(dados.larguraCodBarras);
                        setAlturaCodBarras(dados.alturaCodBarras);
                        setHabilitaCodBarras(dados.habilitaCodBarras);
                        setExibirCodEanNumerico(dados.exibirCodigoEanNumerico);
                        setFormatoCodBarras(dados.formatoCodBarras);
                        setTextTesteNomeProduto(dados.textoExemploNomeProduto);
                        setTextTestePreco(dados.textoExemploPreco);
                        setTextTesteDataValidade(dados.textoExemploDataVencimento);
                        setFontSizeNomeProduto(dados.fontSizeNomeProduto);
                        setFontSizePreco(dados.fontSizePreco);
                        setFontSizeDataValidade(dados.fontSizediasParaVencimento);
                        setFontWeigthNomeProduto(dados.fontWreigthNomeProduto);
                        setFontWeigthPreco(dados.fontWreigthPreco);
                        setFontWeigthDataValidade(dados.fontWreigthDiasVencimento);
                        setFontFamilyNomeProduto(dados.fontNomeProduto);
                        setFontFamilyPreco(dados.fontPreco);
                        setFontFamilyDataValidade(dados.fontDiasParaVencimento);
                        setTextPreNomeProduto(dados.textPreNomeProduto == null ? "": dados.textPreNomeProduto);
                        setTextPrePreco(dados.textPrePreco == null ? "" : dados.textPrePreco);
                        setTextPreDataValidade(dados.textPreDataValidade == null ? "" : dados.textPreDataValidade);
                        setHabilitaPreco(dados.habilitaPreco);
                        setHabilitaDataValidade(dados.habilitaDataValidade);
                        setLimiteCharsPorLinha(dados.limiteCharPorLinha);
                        setLimiteCharsTotal(dados.limiteCharTotal);
                        setFontSizeCodBarras(dados.fontSizeCodBarras);
                        setBoxes(
                            update(boxes, {
                                a: { //nome produtos
                                    $merge: { 
                                        top: dados.yNomeProduto,
                                        left: dados.xNomeProduto,
                                        text: wrapTextAsComponent((dados.textPreNomeProduto + dados.textoExemploNomeProduto).slice(0, dados.limiteCharTotal), parseInt(dados.limiteCharPorLinha)), 
                                        fontSize: dados.fontSizeNomeProduto, 
                                        fontWeight: dados.fontWreigthNomeProduto,
                                        fontFamily: dados.fontNomeProduto
                                    },
                                },
                                b: { //preço
                                    $merge: { 
                                        top: dados.yPreco,
                                        left: dados.xPreco,
                                        text: dados.habilitaPreco ? (dados.textPrePreco + dados.textoExemploPreco) : "" , 
                                        fontSize: dados.fontSizePreco, 
                                        fontWeight: dados.fontWreigthPreco,
                                        fontFamily: dados.fontPreco
                                    },
                                },
                                c: { //data validade
                                    $merge: { 
                                        top: dados.yDiasParaVencimento,
                                        left: dados.xDiasParaVencimento,
                                        text: dados.habilitaDataValidade ? (dados.textPreDataValidade + dados.textoExemploDataVencimento) : "" , 
                                        fontSize: dados.fontSizediasParaVencimento, 
                                        fontWeight: dados.fontWreigthDiasVencimento,
                                        fontFamily: dados.fontDiasParaVencimento
                                    },
                                },
                                d: {
                                    $merge: {
                                        top: dados.yCodigoBarra,
                                        left: dados.xCodigoBarra,
                                        text: dados.habilitaCodBarras ? <Barcode
                                            value={codEanTeste}
                                            width={cmToPx(dados.larguraCodBarras) / 100}
                                            height={cmToPx(dados.alturaCodBarras)}
                                            margin={5}
                                            displayValue={dados.exibirCodigoEanNumerico}
                                            format={dados.formatoCodBarras}
                                        />
                                        : null
                                    }
                                }
                            })
                        );
                        
                    }else{
                        setMsgModalErro('Erro ao buscar molde: ' + response.data.msg);
                        setShowModalErro(true);
                    }
                })
                .catch((error) => {
                    setMsgModalErro('Erro ao buscar molde: ' + tratamentoErro(error));
                    setShowModalErro(true);
                })
                .finally(() => setShowModalLoad(false));
            }
        }

        funcBuscarUnicoMolde();

    }, []);

    const funcSalvar = async () => {

        //console.log({
        //     nomeMolde: nomeMolde,
        //     largura: largura,
        //     altura: altura,
        //     numeroColunas: numeroColunas,
        //     espacamento: espacamento,
        // });
        
        if(nomeMolde == "" || largura == "" || altura == "" || numeroColunas == "" || (espacamento == "" && espacamento != 0) ){
            setMsgModalErro('Erro ao salvar molde: Não pode haver campos vazios!');
            setShowModalErro(true);

            return;
        }

        if(boxes.a.fontSize == '' || boxes.b.fontSize == '' || boxes.c.fontSize == '' ){
            setMsgModalErro('Erro ao salvar molde: Defina o tamanho da fonte!');
            setShowModalErro(true);

            return;
        }

        setShowModalLoad(true);

        //salvar molde
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: global.baseUrl + '/AppEtiqueta/CadastrarEditarMolde',
            headers: { 
                'Authorization': await getToken(user.clientKey),
                'Content-Type': 'application/json'
            },
            data : {
                "uuidMolde": id_molde,
                "nome": nomeMolde,
                "largura": parseFloat(largura),
                "altura": parseFloat(altura),
                "numCol": parseInt(numeroColunas),
                "espacamento": parseFloat(espacamento),
                "x_nomeProduto": boxes.a.left,
                "y_nomeProduto": boxes.a.top,
                "x_dataVencimento": boxes.c.left,
                "y_dataVencimento": boxes.c.top,
                "x_preco": boxes.b.left,
                "y_preco": boxes.b.top,
                "x_CodBarras": boxes.d.left,
                "y_CodBarras": boxes.d.top,
                "fontSizeNomeProduto": parseFloat(fontSizeNomeProduto),
                "fontSizeDataVencimento": parseFloat(fontSizeDataValidade),
                "fontSizePreco": parseFloat(fontSizePreco),
                "fontWreigthNomeProduto": fontWeithtNomeProduto,
                "fontWreigthDataVencimento": fontWeithtDataValidade,
                "fontWreigthPreco": fontWeithtPreco,
                "fontNomeProduto": fontFamilyNomeProduto,
                "fontDataVencimento": fontFamilyDataValidade,
                "fontPreco": fontFamilyPreco,
                "textoExemploNomeProduto": textTesteNomeProduto,
                "textoExemploDataVencimento": textTesteDataValidade,
                "textoExemploPreco": textTestePreco,
                "habilitaCodBarras": habilitaCodBarras,
                "alturaCodBarras": parseFloat(alturaCodBarras),
                "larguraCodBarras": parseFloat(larguraCodBarras),
                "fontSizeCodBarras": parseFloat(fontSizeCodBarras),
                "exibirCodEanNumerico": exibirCodEanNumerico,
                "formatoCodBarras": formatoCodBarras,
                "textPreNomeProduto": textPreNomeProduto,
                "textPreDataValidade": textPreDataValidade,
                "textPrePreco": textPrePreco,
                "habilitaPreco": habilitaPreco,
                "habilitaDataValidade": habilitaDataValidade,
                "limiteCharPorLinha": parseInt(limiteCharsPorLinha),
                "limiteCharTotal": parseInt(limiteCharsTotal)
            }
        };

        axios.request(config)
        .then((response) => {
            //console.log(response);
            if(response.data.code == 0){
                // setMsgModalSucesso('Molde salvo com sucesso!');
                // setShowModalSucesso(true);
                window.location.href = "/cadastrareditarmolde?id=" + response.data.content;
            }else{
                setMsgModalErro('Erro ao salvar molde: ' + response.data.msg);
                setShowModalErro(true);
            }
        })
        .catch((error) => {
            setMsgModalErro('Erro ao salvar molde: ' + tratamentoErro(error));
            setShowModalErro(true);
        })
        .finally(() => setShowModalLoad(false));

    };

    return(
        <div style={{marginRight: 50, marginLeft: 50}}>
            <ModalErro
                showModal={showModalErro}
                setShowModal={setShowModalErro}
                msg={msgModalErro}
                funcPos={funcPosModalErro}
            />
            <ModalSucesso
                showModal={showModalSucesso}
                setShowModal={setShowModalSucesso}
                msg={msgModalSucesso}
                funcPos={funcPosModalSucesso}
            />
            <ModalLoad showModal={showModalLoad} />
            <Grid container>
                <h2>Cadastrar/Editar moldes</h2>
            </Grid>
            <hr />
            <Box  display="flex" gap={1}>
                <TextField 
                    label="Nome do molde"
                    value={nomeMolde}
                    onChange={(event) => setNomeMolde(event.target.value)}
                    variant="outlined"
                    fullWidth
                />
                <TextField 
                    label="Espaçamento entre colunas: "
                    type={'number'}
                    step={'0.1'}
                    value={espacamento}
                    onChange={(e) => setEspacamento(e.target.value)}
                    variant="outlined"
                    fullWidth
                />
            </Box>
            {/* <Row style={{marginTop: 10}}>
                <Col>
                    <Form.Label>Nome do molde</Form.Label>
                    <Form.Control
                        type="text"
                        value={nomeMolde}
                        onChange={(event) => setNomeMolde(event.target.value)}
                    />
                </Col>
                <Col>
                    <Form.Label>Espaçamento entre colunas: </Form.Label>
                    <Form.Control
                        type={'number'}
                        step={'0.1'}
                        min={0.1}
                        value={espacamento}
                        onChange={(e) => setEspacamento(e.target.value)}
                    />
                </Col>
            </Row> */}
            <Box  display="flex" gap={1} mt={2}>
                <TextField 
                    label="Nº colunas"
                    type={'number'}
                    step={1}
                    value={numeroColunas}
                    onChange={(e) => setNumeroColunas(e.target.value)}
                    variant="outlined"
                    fullWidth
                />
                <TextField 
                    label="Largura (cm): "
                    type={'number'}
                    step={1}
                    value={largura}
                    onChange={(e) => setLargura(e.target.value)}
                    variant="outlined"
                    fullWidth
                />
                <TextField 
                    label="Altura (cm): "
                    type={'number'}
                    step={1}
                    value={altura}
                    onChange={(e) => setAltura(e.target.value)}
                    variant="outlined"
                    fullWidth
                />
            </Box>
            {/* <Row style={{ marginTop: 10}}>
                
                <Col>
                    <Form.Label>Num colunas</Form.Label>
                    <Form.Control
                        type={'number'}
                        step={1}
                        min={1}
                        value={numeroColunas}
                        onChange={(e) => setNumeroColunas(e.target.value)}
                    />
                </Col>
                <Col>
                    <Form.Label>Largura (cm)</Form.Label>
                    <Form.Control
                        type={'number'}
                        step={1}
                        min={1}
                        value={largura}
                        onChange={(e) => setLargura(e.target.value)}
                    />
                </Col>
                <Col>
                    <Form.Label>Altura (cm)</Form.Label>
                    <Form.Control
                        type={'number'}
                        step={1}
                        min={1}
                        value={altura}
                        onChange={(e) => setAltura(e.target.value)}
                    />
                </Col>
            </Row> */}
            <hr />
            <Grid container spacing={2} mb={2}>
                <Button variant="contained" color="primary" fullWidth onClick={funcSalvar}>
                    Salvar
                </Button>
            </Grid>
            <Grid container alignItems="center">
                <Divider sx={{ flexGrow: 1 }} />
                <Box px={2} color="black">
                {!showMoreConfigm ? (
                    <CiCirclePlus size={30} onClick={() => setShowMoreConfigm(true)} />
                ) : (
                    <CiCircleMinus size={30} onClick={() => setShowMoreConfigm(false)} />
                )}
                </Box>
                <Divider sx={{ flexGrow: 1 }} />
            </Grid>
            {showMoreConfigm && (
                <Box mt={2}>
                    {/* Nome Produto */}
                    <Grid container spacing={2}>
                        <Grid 
                            sx={{ 
                                flex: {md: 6, sm: 12, xs: 12},
                            }}
                        >
                            <Box p={2} border="1px solid black" borderRadius={2}>
                                <Typography variant="h6">Nome Produto:</Typography>
                                <Divider sx={{ my: 1 }} />
                                <TextField
                                label="Tamanho da fonte"
                                type="number"
                                step="0.1"
                                value={espacamento}
                                onChange={(e) => setEspacamento(e.target.value)}
                                fullWidth
                                margin="dense"
                                />
                                <TextField
                                label="Tamanho da fonte"
                                type="number"
                                step="1"
                                value={fontSizeNomeProduto}
                                onChange={(e) => setFontSizeNomeProduto(e.target.value)}
                                fullWidth
                                margin="dense"
                                />
                                <FormControl fullWidth margin="dense">
                                <InputLabel>Estilo da fonte</InputLabel>
                                <Select
                                    value={fontWeithtNomeProduto}
                                    onChange={(e) => setFontWeigthNomeProduto(e.target.value)}
                                >
                                    {fontWeights.map((font) => (
                                    <MenuItem key={font} value={font}>
                                        {font}
                                    </MenuItem>
                                    ))}
                                </Select>
                                </FormControl>
                                <FormControl fullWidth margin="dense">
                                <InputLabel>Fonte</InputLabel>
                                <Select
                                    value={fontFamilyNomeProduto}
                                    onChange={(e) => setFontFamilyNomeProduto(e.target.value)}
                                >
                                    {fontFamilies.map((font) => (
                                    <MenuItem key={font} value={font}>
                                        {font}
                                    </MenuItem>
                                    ))}
                                </Select>
                                </FormControl>
                                <TextField
                                label="Texto Pré"
                                type="text"
                                value={textPreNomeProduto}
                                onChange={(e) => setTextPreNomeProduto(e.target.value)}
                                fullWidth
                                margin="dense"
                                />
                                <TextField
                                label="Texto de exemplo"
                                type="text"
                                value={textTesteNomeProduto}
                                onChange={(e) => setTextTesteNomeProduto(e.target.value)}
                                fullWidth
                                margin="dense"
                                />
                                <TextField
                                label="Limitar caracteres por linha"
                                type="number"
                                step="1"
                                value={limiteCharsPorLinha}
                                onChange={(e) => setLimiteCharsPorLinha(e.target.value)}
                                fullWidth
                                margin="dense"
                                />
                                <TextField
                                label="Limite caracteres total"
                                type="number"
                                step="1"
                                value={limiteCharsTotal}
                                onChange={(e) => setLimiteCharsTotal(e.target.value)}
                                fullWidth
                                margin="dense"
                                />
                            </Box>
                        </Grid> 
                        <Box
                            sx={{
                                p: 2,
                                border: "1px solid",
                                borderColor: "black",
                                borderRadius: 2,
                                flex: {md: 6, sm: 12, xs: 12},
                            }}
                        >
                            <Box
                                sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                }}
                            >
                                <Typography variant="h6">Preço:</Typography>
                                <FormControlLabel
                                control={
                                    <Switch
                                    checked={habilitaPreco}
                                    onChange={(e) => setHabilitaPreco(e.target.checked)}
                                    />
                                }
                                label=""
                                />
                            </Box>

                            {habilitaPreco && (
                                <>
                                <Divider sx={{ my: 2 }} />
                                <Stack spacing={2}>
                                    <TextField
                                    label="Tamanho da fonte"
                                    type="number"
                                    value={fontSizePreco}
                                    onChange={(e) => setFontSizePreco(e.target.value)}
                                    inputProps={{ step: 1 }}
                                    fullWidth
                                    />

                                    <Select
                                    label="Estilo da fonte"
                                    value={fontWeithtPreco}
                                    onChange={(e) => setFontWeigthPreco(e.target.value)}
                                    fullWidth
                                    displayEmpty
                                    >
                                    {fontWeights.map((font) => (
                                        <MenuItem key={font} value={font}>
                                        {font}
                                        </MenuItem>
                                    ))}
                                    </Select>

                                    <Select
                                    label="Fonte"
                                    value={fontFamilyPreco}
                                    onChange={(e) => setFontFamilyPreco(e.target.value)}
                                    fullWidth
                                    displayEmpty
                                    >
                                    {fontFamilies.map((font) => (
                                        <MenuItem key={font} value={font}>
                                        {font}
                                        </MenuItem>
                                    ))}
                                    </Select>

                                    <TextField
                                    label="Texto Pré"
                                    type="text"
                                    value={textPrePreco}
                                    onChange={(e) => setTextPrePreco(e.target.value)}
                                    fullWidth
                                    />

                                    <TextField
                                    label="Texto de exemplo"
                                    type="text"
                                    value={textTestePreco}
                                    onChange={(e) => setTextTestePreco(e.target.value)}
                                    fullWidth
                                    />
                                </Stack>
                                </>
                            )}
                        </Box>
                    </Grid>
                    <Grid container spacing={2} mt={2}>
                        {/* Data Validade */}
                        <Box
                            sx={{
                                p: 2,
                                border: "1px solid",
                                borderColor: "black",
                                borderRadius: 2,
                                flex: {md: 6, sm: 12, xs: 12},
                            }}
                        >
                            <Box >
                                
                                <Box
                                    sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    }}
                                >
                                    <Typography variant="h6">Data validade:</Typography>
                                    <FormControlLabel
                                    control={
                                        <Switch
                                            checked={habilitaDataValidade}
                                            onChange={(e) => setHabilitaDataValidade(e.target.checked)}
                                        />
                                    }
                                    label=""
                                    />
                                </Box>
                                

                                {habilitaDataValidade && (
                                    <>
                                    <Divider sx={{ my: 1 }} />
                                    <Grid container spacing={2}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            label="Tamanho da fonte"
                                            value={fontSizeDataValidade}
                                            onChange={(e) => setFontSizeDataValidade(e.target.value)}
                                        />
                                        <FormControl fullWidth>
                                            <InputLabel>Estilo da fonte</InputLabel>
                                            <Select
                                            value={fontWeithtDataValidade}
                                            onChange={(e) => setFontWeigthDataValidade(e.target.value)}
                                            label="Estilo da fonte"
                                            >
                                            {fontWeights.map((font) => (
                                                <MenuItem key={font} value={font}>
                                                {font}
                                                </MenuItem>
                                            ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl fullWidth>
                                            <InputLabel>Fonte</InputLabel>
                                            <Select
                                            value={fontFamilyDataValidade}
                                            onChange={(e) => setFontFamilyDataValidade(e.target.value)}
                                            label="Fonte"
                                            >
                                            {fontFamilies.map((font) => (
                                                <MenuItem key={font} value={font}>
                                                {font}
                                                </MenuItem>
                                            ))}
                                            </Select>
                                        </FormControl>
                                        <TextField
                                            fullWidth
                                            label="Texto Pré"
                                            value={textPreDataValidade}
                                            onChange={(e) => setTextPreDataValidade(e.target.value)}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Texto de exemplo"
                                            value={textTesteDataValidade}
                                            onChange={(e) => setTextTesteDataValidade(e.target.value)}
                                        />
                                    </Grid>
                                    </>
                                )}
                            </Box>
                        </Box>

                        {/* Código de barras */}
                        <Box
                            sx={{
                                p: 2,
                                border: "1px solid",
                                borderColor: "black",
                                borderRadius: 2,
                                flex: {md: 6, sm: 12, xs: 12},
                            }}
                        >
                            <Box>
                                
                                <Box
                                    sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    }}
                                >
                                    <Typography variant="h6">Código de barras:</Typography>
                                    <FormControlLabel
                                    control={
                                        <Switch
                                            checked={habilitaCodBarras}
                                            onChange={(e) => setHabilitaCodBarras(e.target.checked)}
                                        />
                                    }
                                    label=""
                                    />
                                </Box>

                                {habilitaCodBarras && (
                                <>
                                    <Divider sx={{ my: 1 }} />
                                    <Grid container spacing={2}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            label="Largura"
                                            value={larguraCodBarras}
                                            onChange={(e) => setLarguraCodBarras(e.target.value)}
                                        />
                                        <TextField
                                            fullWidth
                                            type="number"
                                            label="Altura"
                                            value={alturaCodBarras}
                                            onChange={(e) => setAlturaCodBarras(e.target.value)}
                                        />
                                        
                                        <TextField
                                        label="Tamanho da fonte"
                                        type="number"
                                        value={fontSizeCodBarras}
                                        onChange={(e) => setFontSizeCodBarras(e.target.value)}
                                        inputProps={{ step: 1 }}
                                        fullWidth
                                        />
                                        <FormControl fullWidth>
                                            <InputLabel>Formato</InputLabel>
                                            <Select
                                            value={formatoCodBarras}
                                            onChange={(e) => setFormatoCodBarras(e.target.value)}
                                            label="Formato"
                                            >
                                            {[
                                                "CODE39",
                                                "CODE128",
                                                "CODE128A",
                                                "CODE128B",
                                                "CODE128C",
                                                "EAN13",
                                                "EAN8",
                                                "EAN5",
                                                "EAN2",
                                                "UPC",
                                                "UPCE",
                                                "ITF14",
                                                "ITF",
                                                "MSI",
                                                "MSI10",
                                                "MSI11",
                                                "MSI1010",
                                                "MSI1110",
                                                "pharmacode",
                                                "codabar",
                                                "GenericBarcode",
                                            ].map((form) => (
                                                <MenuItem key={form} value={form}>
                                                {form}
                                                </MenuItem>
                                            ))}
                                            </Select>
                                        </FormControl>
                                        <Grid flex={{xs: 10}}>
                                            <Typography>Exibir código numérico:</Typography>
                                        </Grid>
                                        <Grid flex={{xs: 2}}>
                                            <FormControlLabel
                                                control={
                                                <Switch
                                                    checked={exibirCodEanNumerico}
                                                    onChange={(e) =>
                                                    setExibirCodEanNumerico(e.target.checked)
                                                    }
                                                />
                                                }
                                                label=""
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                                )}
                            </Box>
                        </Box>
                    </Grid>

                </Box>
            )}
            <hr />
            {/* Painel */}
            <Grid
                sx={{
                    whiteSpace: "nowrap",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    mt: 2,
                    mb: 2,
                    overflowX: "hidden", // rolagem horizontal
                    flex: {md: 12},
                }}
            >
                <Painel
                sx={{ mt: 1, mb: 2 }}
                height={altura}
                width={largura}
                boxes={boxes}
                setBoxes={setBoxes}
                editable
                />
            </Grid>
            <hr />
            {/* Preview */}
            <Grid item xs={12} mt={2}>
                <Grid container alignItems="center">
                    <Typography variant="h6" sx={{ mr: 2 }}>
                        Preview
                    </Typography>
                </Grid>

                <Grid container alignItems="center" sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mr: 2 }}>
                        Largura (cm) da linha: {larguraLinhaPreview}
                    </Typography>
                    <Slider
                        value={larguraLinhaPreview}
                        min={1}
                        max={100}
                        onChange={(e, value) => setLarguraLinhaPreview(value)}
                        sx={{ width: 200 }}
                    />
                </Grid>


                <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ display: "flex" }}
                >
                    <ContainerPreview
                        width={largura}
                        height={altura}
                        boxes={boxes}
                        num_col={numeroColunas}
                        espacamento={espacamento}
                    />
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                    <Box
                        component="hr"
                        sx={{
                            width: `${larguraLinhaPreview}cm`,
                            border: "none",
                            borderTop: "5px solid black",
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    );
}
